import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from '@phosphor-icons/react'

export default function TermsPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-slate-900">
      {/* Header */}
      <header className="bg-slate-900/80 backdrop-blur-lg border-b border-slate-800 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
            >
              <ArrowLeft size={20} />
              Voltar
            </button>
            <img src="/logo.png" alt="Eximtech" className="h-8 w-auto" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-white mb-8">Termos de Uso</h1>

        <div className="prose prose-invert prose-slate max-w-none">
          <p className="text-slate-300 mb-6">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">1. Aceitação dos Termos</h2>
            <p className="text-slate-400 mb-4">
              Ao acessar e usar a plataforma Eximtech, você concorda em cumprir e estar vinculado a estes Termos de Uso.
              Se você não concordar com qualquer parte destes termos, não poderá acessar ou usar nossos serviços.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">2. Descrição do Serviço</h2>
            <p className="text-slate-400 mb-4">
              A Eximtech é uma plataforma digital que conecta embarcadores (empresas que necessitam de serviços de
              logística internacional) com agentes de carga (empresas que fornecem serviços de frete internacional).
              Nossa plataforma facilita:
            </p>
            <ul className="list-disc list-inside text-slate-400 mb-4 space-y-2">
              <li>Solicitação e recebimento de cotações de frete</li>
              <li>Comparação de propostas de diferentes agentes de carga</li>
              <li>Gestão de operações de importação e exportação</li>
              <li>Comunicação entre embarcadores e agentes de carga</li>
              <li>Acompanhamento de embarques e documentação</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">3. Cadastro e Conta</h2>
            <p className="text-slate-400 mb-4">
              Para utilizar nossos serviços, você deve criar uma conta fornecendo informações precisas e completas.
              Você é responsável por:
            </p>
            <ul className="list-disc list-inside text-slate-400 mb-4 space-y-2">
              <li>Manter a confidencialidade de suas credenciais de acesso</li>
              <li>Todas as atividades realizadas em sua conta</li>
              <li>Notificar imediatamente a Eximtech sobre qualquer uso não autorizado</li>
              <li>Manter suas informações de cadastro atualizadas</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">4. Uso Permitido</h2>
            <p className="text-slate-400 mb-4">
              Você concorda em usar a plataforma apenas para fins legítimos relacionados a operações de comércio exterior.
              É expressamente proibido:
            </p>
            <ul className="list-disc list-inside text-slate-400 mb-4 space-y-2">
              <li>Usar a plataforma para atividades ilegais ou fraudulentas</li>
              <li>Transmitir vírus, malware ou código malicioso</li>
              <li>Tentar acessar sistemas ou dados não autorizados</li>
              <li>Interferir no funcionamento da plataforma</li>
              <li>Criar contas falsas ou fornecer informações enganosas</li>
              <li>Violar direitos de propriedade intelectual</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">5. Responsabilidades dos Usuários</h2>
            <h3 className="text-lg font-medium text-white mb-3">5.1. Embarcadores</h3>
            <p className="text-slate-400 mb-4">
              Os embarcadores são responsáveis por fornecer informações precisas sobre suas cargas, incluindo
              dimensões, peso, natureza da mercadoria e requisitos especiais de manuseio.
            </p>
            <h3 className="text-lg font-medium text-white mb-3">5.2. Agentes de Carga</h3>
            <p className="text-slate-400 mb-4">
              Os agentes de carga são responsáveis por fornecer cotações precisas e cumprir os serviços acordados.
              Devem possuir todas as licenças e autorizações necessárias para operar.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">6. Limitação de Responsabilidade</h2>
            <p className="text-slate-400 mb-4">
              A Eximtech atua como intermediária entre embarcadores e agentes de carga. Não somos responsáveis por:
            </p>
            <ul className="list-disc list-inside text-slate-400 mb-4 space-y-2">
              <li>A execução dos serviços de frete contratados através da plataforma</li>
              <li>Danos, perdas ou atrasos nas cargas</li>
              <li>Disputas comerciais entre usuários</li>
              <li>Informações fornecidas por terceiros</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">7. Propriedade Intelectual</h2>
            <p className="text-slate-400 mb-4">
              Todo o conteúdo da plataforma, incluindo mas não limitado a textos, gráficos, logos, ícones, imagens,
              software e código, é propriedade da Eximtech ou de seus licenciadores e está protegido por leis de
              propriedade intelectual.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">8. Modificações dos Termos</h2>
            <p className="text-slate-400 mb-4">
              Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. As alterações entrarão
              em vigor imediatamente após a publicação na plataforma. O uso continuado dos serviços após as
              modificações constitui aceitação dos novos termos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">9. Rescisão</h2>
            <p className="text-slate-400 mb-4">
              Podemos suspender ou encerrar sua conta a qualquer momento, com ou sem motivo, incluindo, sem
              limitação, violação destes Termos de Uso. Você pode encerrar sua conta a qualquer momento
              entrando em contato conosco.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">10. Lei Aplicável</h2>
            <p className="text-slate-400 mb-4">
              Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Qualquer disputa
              será resolvida pelos tribunais competentes da cidade de São Paulo, SP.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-white mb-4">11. Contato</h2>
            <p className="text-slate-400 mb-4">
              Para dúvidas sobre estes Termos de Uso, entre em contato conosco:
            </p>
            <p className="text-slate-400">
              E-mail: contato@eximtech.com.br
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-4 sm:px-6 lg:px-8 bg-slate-900 border-t border-slate-800">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-slate-400 text-sm">
            &copy; {new Date().getFullYear()} Eximtech. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  )
}
